<rt-icon-help
  #infoDropdownTrigger="rtOverlayOrigin"
  [class.dropdownOpened]="dropdownOpen"
  [rtTooltip]="translations.clickForHelp | translate"
  rt-overlay-origin
>
</rt-icon-help>
<ng-template
  #infoDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [origin]="infoDropdownTrigger"
  [open]="dropdownOpen"
  [positions]="positions"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-dropdown>
    <rt-dropdown-item variant="plain">
      <rt-heading variant="subheading small">
        {{ infoText }}
      </rt-heading>
    </rt-dropdown-item>
    <rt-dropdown-item
      *ngIf="link"
      [href]="link"
      hrefTarget="_blank"
      (click)="handleLinkClick()"
      variant="plain footer"
    >
      {{ translations.learnMore | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item *ngIf="contactSupport" (click)="openIntercomChat()" variant="plain footer">
      {{ translations.contactSupport | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
